<ng-template #authTemplate><div [innerHtml]="accessService.authReason(project, 'EDIT_REPORTING')"></div></ng-template>

<div class="card-header bg-white" *ngIf="accessService.authorized(project, 'EDIT_REPORTING')">

    <button type="button" class="btn btn-primary" placement="right" containerClass="auth-tooltip"
            *ngIf="viewMode === ViewMode.VIEW"
            (click)="addStatusReport()"
            [tooltip]="authTemplate"
            [disabled]="!(accessService.hasRights(Right.PMO) || (statusMissing && accessService.hasRoles(project, TeamRole.Lead)))"
            [delay]="500">Statusbericht hinzufügen
    </button>

    <ng-container *ngIf="viewMode === ViewMode.EDIT">
        <button type="button" class="btn btn-success" [disabled]="form.invalid" (click)="updateStatusReport()">
            Speichern
        </button>
        <button type="button" class="btn btn-secondary ms-2" (click)="cancelForm()">Abbrechen</button>
    </ng-container>

    <ng-container *ngIf="viewMode === ViewMode.INSERT">
        <button type="button" class="btn btn-success" [disabled]="form.invalid" (click)="saveStatusReport()">
            Speichern
        </button>
        <button type="button" class="btn btn-secondary ms-2" (click)="cancelForm()">Abbrechen</button>
    </ng-container>
</div>

<div class="card-body">
    <form [formGroup]="form" *ngIf="viewMode !== ViewMode.VIEW">
        <h4>Neuer Statusbericht</h4>

        <div class="mb-2">
            <label>Arbeitsinhalt</label>
            <textarea class="form-control" formControlName="description" rows="4"
                      placeholder="Wichtigsten Kernthemen die im letzten Monat im Rahmen des Projekts behandelt wurden.">
            </textarea>
        </div>

        <div class="row">
            <div class="col">
                <div class="mb-2">
                    <div><label>Inhalt</label></div>
                    <div class="btn-group w-100" role="group">
                        <button type="button" class="btn btn-secondary btn-sm"
                                [class.btn-success]="form.value.content === 'success'"
                                (click)="patchValue('content', 'success')">im Plan
                        </button>
                        <button type="button" class="btn btn-secondary btn-sm"
                                [class.btn-warning]="form.value.content === 'warning'"
                                (click)="patchValue('content', 'warning')">leichte Veränderung
                        </button>
                        <button type="button" class="btn btn-secondary btn-sm"
                                [class.btn-danger]="form.value.content === 'danger'"
                                (click)="patchValue('content', 'danger')">Handlungsbedarf
                        </button>
                    </div>
                </div>
                <div class="row" *ngIf="form.value.content !== 'success'">
                    <div class="col">
                        <div class="mb-2">
                            <label>Maßnahme</label>
                            <textarea class="form-control" formControlName="action_content" rows="4"
                                      [placeholder]="placeHolderContent">
                            </textarea>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="mb-2">
                    <div><label>Zeit</label></div>
                    <div class="btn-group w-100" role="group">
                        <button type="button" class="btn btn-secondary btn-sm"
                                [class.btn-success]="form.value.time === 'success'"
                                (click)="patchValue('time', 'success')">im Plan
                        </button>
                        <button type="button" class="btn btn-secondary btn-sm"
                                [class.btn-warning]="form.value.time === 'warning'"
                                (click)="patchValue('time', 'warning')">leichte Veränderung
                        </button>
                        <button type="button" class="btn btn-secondary btn-sm"
                                [class.btn-danger]="form.value.time === 'danger'"
                                (click)="patchValue('time', 'danger')">Handlungsbedarf
                        </button>
                    </div>
                </div>
                <div class="row" *ngIf="form.value.time !== 'success'">
                    <div class="col">
                        <div class="mb-2">
                            <label>Maßnahme</label>
                            <textarea class="form-control" formControlName="action_time" rows="4"
                                      [placeholder]="placeHolderTime">
                            </textarea>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="mb-2">
                    <div><label>Kosten</label></div>
                    <div class="btn-group w-100" role="group">
                        <button type="button" class="btn btn-secondary btn-sm"
                                [class.btn-success]="form.value.costs === 'success'"
                                (click)="patchValue('costs', 'success')">im Plan
                        </button>
                        <button type="button" class="btn btn-secondary btn-sm"
                                [class.btn-warning]="form.value.costs === 'warning'"
                                (click)="patchValue('costs', 'warning')">leichte Veränderung
                        </button>
                        <button type="button" class="btn btn-secondary btn-sm"
                                [class.btn-danger]="form.value.costs === 'danger'"
                                (click)="patchValue('costs', 'danger')">Handlungsbedarf
                        </button>
                    </div>
                </div>
                <div class="row" *ngIf="form.value.costs !== 'success'">
                    <div class="col">
                        <div class="mb-2">
                            <label>Maßnahme</label>
                            <textarea class="form-control" formControlName="action_costs" rows="4"
                                      [placeholder]="placeHolderCosts">
                            </textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <ng-container *ngIf="viewMode === ViewMode.VIEW">
        <h4>Statusberichte ({{ statusReports.length}})</h4>

        <div class="alert alert-warning" role="alert" *ngIf="statusMissing">Der Statusbericht für das aktuelle Monat ist noch ausständig!</div>

        <table class="table table-striped table-sm mb-0">
            <thead>
            <tr>
                <th style="width: 45px"></th>
                <th>#</th>
                <th style="width: 120px">Datum</th>
                <th>Arbeitsinhalt</th>
                <th>Status</th>
                <th style="width: 400px">Feedback</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let entry of statusReports; let i = index">
                <td>
                    <button type="button" class="btn btn-primary btn-sm" placement="right" containerClass="auth-tooltip"
                            *ngIf="accessService.authorized(project, 'EDIT_REPORTING')"
                            (click)="editStatusReport(entry)"
                            [tooltip]="authTemplate"
                            [delay]="500"><i class="fas fa-pencil"></i>
                    </button>
                </td>
                <td>
                    {{ statusReports.length - i }}
                </td>
                <td>
                    {{ entry.created_at | date: 'dd.MM.yyyy HH:mm'}}
                </td>
                <td [innerHTML]="entry.descriptionWithBreaks">

                </td>
                <td>
                    <div class="row">
                        <div class="col-2">
                            <h6 class="mb-0"><span class="badge"
                                      [class.bg-success]="entry.content === 'success'"
                                      [class.bg-warning]="entry.content === 'warning'"
                                      [class.bg-danger]="entry.content === 'danger'"
                            >Inhalt</span></h6>
                        </div>
                        <div class="col" [innerHTML]="entry.actionWithBreaks">

                        </div>
                    </div>
                    <div class="row my-1 py-1" style="border-top: 1px solid #ddd; border-bottom: 1px solid #ddd">
                        <div class="col-2">
                            <h6 class="mb-0"><span class="badge"
                                      [class.bg-success]="entry.time === 'success'"
                                      [class.bg-warning]="entry.time === 'warning'"
                                      [class.bg-danger]="entry.time === 'danger'"
                            >Zeit</span></h6>
                        </div>
                        <div class="col" [innerHTML]="entry.timeWithBreaks">

                        </div>
                    </div>
                    <div class="row">
                        <div class="col-2">
                            <h6 class="mb-0"><span class="badge"
                                      [class.bg-success]="entry.costs === 'success'"
                                      [class.bg-warning]="entry.costs === 'warning'"
                                      [class.bg-danger]="entry.costs === 'danger'"
                            >Kosten</span></h6>
                        </div>
                        <div class="col" [innerHTML]="entry.costsWithBreaks">

                        </div>
                    </div>
                </td>
                <td>
                    <ng-container *ngIf="accessService.authorized(project, 'EDIT_FEEDBACK')">
                        <textarea class="form-control" [(ngModel)]="entry.feedback" rows="5"></textarea>
                        <button type="button" class="btn btn-primary btn-sm mt-1" (click)="saveFeedback(entry)">Speichern</button>
                    </ng-container>

                    <p *ngIf="!accessService.authorized(project, 'EDIT_FEEDBACK')">
                        {{ entry.feedback }}
                        <span class="text-muted" *ngIf="!entry.feedback">Nicht eingetragen</span>
                    </p>
                </td>
            </tr>
            </tbody>
        </table>

    </ng-container>
</div>
